import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { ITagsSlice } from "../../interfaces/interfaces"

const TagsSliceState: ITagsSlice = {
    selectedTags: [],
    viewersTagsList: [],
    inputTagSearch: undefined,
    inputFilterTagSearch: "",
    isMovieFilter: false,
    isSeriesFilter: false,
}


export const tagsSlice = createSlice({
    name: 'tags',
    initialState: TagsSliceState,
    reducers: {
        setSelectedTags: (state, action: PayloadAction<string[]>) => {
            state.selectedTags = action.payload
        },
        setViewersTagsList: (state, action: PayloadAction<string[]>) => {
            state.viewersTagsList = action.payload
        },
        setInputTagSearch: (state, action: PayloadAction<string>) => {
            state.inputTagSearch = action.payload
        },
        setInputFilterTagSearch: (state, action: PayloadAction<string>) => {
            state.inputFilterTagSearch = action.payload
        },
        setIsMovieFilter: (state, action: PayloadAction<boolean>) => {
            state.isMovieFilter = action.payload
        },
        setIsSeriesFilter: (state, action: PayloadAction<boolean>) => {
            state.isSeriesFilter = action.payload
        },
        setClearTagsSlice: () => {
            return TagsSliceState
        }
    }
})

export const {
    setSelectedTags,
    setViewersTagsList,
    setInputTagSearch,
    setInputFilterTagSearch,
    setIsMovieFilter,
    setIsSeriesFilter,
    setClearTagsSlice
} = tagsSlice.actions;

export default tagsSlice.reducer;